import { Container } from '#/shared/components/layout/Container';
import { Loading } from '#/shared/components/Loading';

export function LoadingScreen() {
  return (
    <Container className="flex items-center justify-center min-h-screen flex-col space-y-4">
      <Loading loadingText="Loading timesheet..." />
    </Container>
  );
}
